/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ agent: NonNullable<unknown> }} Audit_Details_Agent_Unattended_Destructive_Disabled_DescInputs */



/**
* | output |
* | --- |
* | "The agent \"{agent}\" must now get human approval before every action oneAI recognises as irreversible." |
*
* @param {Audit_Details_Agent_Unattended_Destructive_Disabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_agent_unattended_destructive_disabled_desc = /** @type {((inputs: Audit_Details_Agent_Unattended_Destructive_Disabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Agent_Unattended_Destructive_Disabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Agent "${i?.agent}" benötigt jetzt vor jeder Aktion, die oneAI als unumkehrbar erkennt, eine menschliche Genehmigung.`)
	return /** @type {LocalizedString} */ (`The agent "${i?.agent}" must now get human approval before every action oneAI recognises as irreversible.`)
});